var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_delete",
    "data-name": "ico delete",
    transform: "translate(15.423 13.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 50,
    height: 50,
    rx: 4,
    transform: "translate(-15.423 -13.406)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1175",
    "data-name": "Trazado 1175",
    d: "M156.939,151.579v14.3a2.935,2.935,0,0,1-2.913,2.914h-9.894a2.892,2.892,0,0,1-2.913-2.914v-14.3H139.66a.678.678,0,0,1,0-1.355H144.4v-.746a2.112,2.112,0,0,1,2.1-2.1h5.15a2.112,2.112,0,0,1,2.1,2.1v.746H158.5a.678.678,0,0,1,0,1.355Zm-11.18-1.355h6.64v-.746a.752.752,0,0,0-.745-.745H146.5a.752.752,0,0,0-.745.745Zm-3.185,1.355v14.3a1.533,1.533,0,0,0,1.558,1.558h9.894a1.576,1.576,0,0,0,1.558-1.558v-14.3Z",
    transform: "translate(-139 -147.378)",
    fill: "#e6007e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1176",
    "data-name": "Trazado 1176",
    d: "M145.5,155.114a.678.678,0,0,1,1.356,0v8.606a.678.678,0,0,1-1.356,0Z",
    transform: "translate(-138.949 -147.322)",
    fill: "#e6007e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1177",
    "data-name": "Trazado 1177",
    d: "M151.151,155.114a.678.678,0,0,1,1.356,0v8.606a.678.678,0,0,1-1.356,0Z",
    transform: "translate(-138.904 -147.322)",
    fill: "#e6007e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1178",
    "data-name": "Trazado 1178",
    d: "M148.328,155.114a.678.678,0,0,1,1.355,0v8.606a.678.678,0,0,1-1.355,0Z",
    transform: "translate(-138.926 -147.322)",
    fill: "#e6007e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePink);
export default __webpack_public_path__ + "static/media/delete-pink.8880c8526ff244927a7b47673a316b85.svg";
export { ForwardRef as ReactComponent };